import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import './styles.css';

const { Column } = Table;

const ReservationsByDateTableResto = ({ data }) => {
    return (
        <Table className="reservationsByDateTableResto" dataSource={data} rowKey="date" size="small" pagination={false}>
            <Column title="Fecha" dataIndex="date" key="date" align="center"/>
            <Column title="Total de personas por fecha" dataIndex="peopleTotalCount" key="peopleTotalCount" align="center" />
            <Column title="Cantidad de reservas" dataIndex="reservationCount" key="reservationCount" align="center" />
            <Column title="Reservas aceptadas" dataIndex="reservationsAcceptedCount" key="reservationsAcceptedCount" align="center" />
            <Column title="Reservas rechazadas" dataIndex="reservationsRejectedCount" key="reservationsRejectedCount" align="center" />
            <Column title="Reservas canceladas" dataIndex="reservationsCancelledCount" key="reservationsCancelledCount" align="center" />
        </Table>
    );
};

ReservationsByDateTableResto.propTypes = {
    data: PropTypes.array.isRequired,
};

export default ReservationsByDateTableResto;